import React from "react";
import { Box, FormControlLabel, Switch, SxProps, Theme } from "@mui/material";

export interface TableModeSwitchProps {
  checked: boolean;
  onChange: (nextIsTable: boolean) => void;
  sx?: SxProps<Theme>;
}

/**
 * Shared Modern UI control: toggles dense tabular layouts where supported.
 */
const TableModeSwitch: React.FC<TableModeSwitchProps> = ({
  checked,
  onChange,
  sx,
}) => (
  <Box sx={sx}>
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          onChange={(_, next) => onChange(next)}
          sx={{
            "& .MuiSwitch-switchBase": { color: "#ff7043" },
            "& .MuiSwitch-switchBase.Mui-checked": { color: "#1976d2" },
            "& .MuiSwitch-track": { backgroundColor: "#e0e0e0" },
            "& .MuiSwitch-thumb": {
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            },
          }}
        />
      }
      label={checked ? "Table view" : "Regular view"}
      labelPlacement="start"
      sx={{ m: 0, userSelect: "none" }}
    />
  </Box>
);

export default TableModeSwitch;
